import { TizenPayload } from 'qp-ui-interface';
import { AdaptedPayload } from './modal/AdaptedPayload';
import { TizenFeedPayload } from './modal/TizenFeedPayload';

const isTizenPayload = (payload: any): payload is TizenPayload => {
  if (!payload) {
    return false;
  }
  return 'cl' in payload;
};

const getAdaptedLanguage = (lang: string): string => {
  switch (lang) {
    case 'te':
      return 'tg';
    case 'tm':
      return 'ta';
    case 'en':
      return 'en';
    default:
      return lang;
  }
};

export const getAdaptedPayload = (
  payload: TizenPayload | TizenFeedPayload
): AdaptedPayload => {
  if (isTizenPayload(payload)) {
    return {
      contentType: payload.ct?.trim(),
      catalogLanguage: payload.cl?.trim(),
      resourceId: payload.id?.trim().replace(/\/$/, ''),
      url: payload.url,
      isPlayable: payload.is_playable,
    };
  } else {
    return undefined;
  }
};

/**
 * Split payload string by separators
 * Format:
 *  acl$$te|||cty$$movie||| id$$0CC7C287-ABAD-4185-BE04-73F7055C1326||| cta$$player
 *
 * @param payload
 * @returns
 */
export const getSplitedPayload = (payload: string): AdaptedPayload => {
  try {
    const values = payload.split('|||');
    return {
      contentType: values[1].split('$$')[1]?.trim(),
      catalogLanguage: getAdaptedLanguage(values[0].split('$$')[1]?.trim()),
      resourceId: values[2].split('$$')[1]?.trim().replace(/\/$/, ''),
      isPlayable: values[3].split('$$')[1]?.trim() === 'player',
    };
  } catch (e) {
    return {
      contentType: undefined,
      catalogLanguage: undefined,
      resourceId: undefined,
      isPlayable: undefined,
    };
  }
};
